import React from 'react';
import { IDevice } from '../../interfaces';
import ReactTags, { Tag } from 'react-tag-autocomplete';
import { useState } from 'react';
import { useEffect } from 'react';
import { downloadScreenList, getShopNb } from '../../utils/pricing';

export const Targeting = (props: {
    availableDevices: IDevice[];
    filtersSign: Tag[];
    filtersOther: Tag[];
    suggestions: Tag[];
    signSuggestions: Tag[];
    selected: number[];
    handleSelectDevices: (filter: any, operation: 'add' | 'delete', filterName: 'filtersSign' | 'filtersOther') => void;
    exclusion: boolean;
    onChangeExclude: (exclude: boolean) => void;
    onSelectAll: (selectAll: boolean) => void;
    openMap: () => void;
    openPois: () => void;
    openDraw: () => void;
    openUpload: () => void;
    openManualSelection: () => void;
}) => {
    const [state, setState] = useState<{ devices: { [key: number]: IDevice } }>({
        devices: {}
    });

    useEffect(() => {
        const devices: { [key: number]: IDevice } = {};
        for (const d of props.availableDevices) {
            devices[d.id] = d;
        }

        setState((prevState) => ({ ...prevState, devices }));
    }, [props.availableDevices]);

    return (
        <div className="targeting">
            <div className="row">
                <div className="selection-controls">
                    <div className="flex-space">
                        <span>A date: {props.availableDevices.length} écrans</span>
                        <div>
                            <span>Tout sélectionner</span>
                            <span
                                className={[
                                    'checkbox',
                                    props.selected.length === props.availableDevices.length ? 'checked' : ''
                                ].reduce((acc, e) => acc + ' ' + e)}
                                onClick={(_) =>
                                    props.onSelectAll(props.selected.length !== props.availableDevices.length)
                                }
                            />{' '}
                            <span>Excluant</span>
                            <span
                                className={['checkbox', props.exclusion ? 'checked' : ''].reduce(
                                    (acc, e) => acc + ' ' + e
                                )}
                                onClick={() => props.onChangeExclude(!props.exclusion)}
                            />
                        </div>
                    </div>
                    <hr />
                    <div className="mb-10">
                        Sélection par filtre (enseigne, ville, code postal, departement, region) :
                    </div>
                    <div className="row c2">
                        <ReactTags
                            onAddition={(e) => props.handleSelectDevices(e, 'add', 'filtersSign')}
                            onDelete={(e) => props.handleSelectDevices(e, 'delete', 'filtersSign')}
                            tags={props.filtersSign}
                            suggestions={props.signSuggestions}
                            placeholderText="Enseigne"
                            minQueryLength={0}
                            maxSuggestionsLength={25}
                        />
                        <ReactTags
                            onAddition={(e) => props.handleSelectDevices(e, 'add', 'filtersOther')}
                            onDelete={(e) => props.handleSelectDevices(e, 'delete', 'filtersOther')}
                            tags={props.filtersOther}
                            suggestions={props.suggestions}
                            placeholderText="Code postal, ville"
                            minQueryLength={2}
                            maxSuggestionsLength={25}
                        />
                    </div>
                </div>
                <div className="selection-recap">
                    <h5>Sélection :</h5>
                    <p>{getShopNb(props.selected.map((i) => state.devices[i]))} Magasins</p>
                    <p>{props.selected.length} Ecrans</p>
                    <div className="controlsScreen">
                        <span
                            onClick={() =>
                                downloadScreenList(
                                    props.selected.map((i) => state.devices[i]),
                                    []
                                )
                            }
                        >
                            Télécharger liste
                        </span>
                        <span onClick={props.openUpload}>Uploader liste</span>
                        <span onClick={props.openPois}>Ajouter POIs</span>
                        <span onClick={props.openDraw}>Dessiner</span>
                        <span onClick={props.openManualSelection}>Sélection manuelle</span>
                        <span onClick={props.openMap}>Voir sur la carte</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
